import * as request from 'superagent';
import { Getters, store } from '@/store';

export abstract class ServiceBase {
  protected static authRequest(req: request.SuperAgentRequest): request.SuperAgentRequest {
    const token = store.getters[Getters.ID_TOKEN];
    if (token === null) {
      throw new Error('User not logged in!');
    }

    return req.set('Authorization', `Bearer ${token}`);
  }
}


export interface IVersionedId {
  id: number;
  version: number;
}

export interface IPage<T> {
  totalItems: number;
  data: T[];
}